import type { VatDeclarationDrillDownBill, VatDeclarationTransactionContribution, VatDeclarationUnusedItem } from "../types/index.ts";
import type { BillDrillDownRow, TransactionDrillDownRow } from "../../DrillDown/index.ts";
import { DrillDownType } from "../../DrillDown/index.ts";
import { isMoney } from "../../../../lib/Money.ts";

export const UNUSED_VAT_LINE_ITEM_MESSAGE = 'Deze regel is niet meegenomen in de BTW aangifte.';

export function mapVatDocsToDrillDownRows(
    bills: VatDeclarationDrillDownBill[],
): BillDrillDownRow[] {
    return bills.map((bill) => {
        const amountTotal = bill?.section_total_amount?.signed_amount ?? null;
        const currency = bill?.section_total_amount?.currency ?? null;

        return {
            id: bill.id,
            type: DrillDownType.BILL,
            documentId: bill.document_id,
            file_name: bill.file_name,
            relation_name: bill.relation_name ?? null,
            date: bill.normalized_date ?? null,
            totalAmount: amountTotal,
            currency,
            netAmount: bill?.section_net_amount?.signed_amount ?? null,
            vatAmount: bill?.section_vat_amount?.signed_amount ?? null,
        };
    });
}

export function mapVatTransactionsToDrillDownRows(
    transactions: VatDeclarationTransactionContribution[],
): TransactionDrillDownRow[] {
    return transactions.map((transaction) => {
        const netAmount = transaction.net?.signed_amount ?? null;
        const vatAmount = transaction.vat?.signed_amount ?? null;
        const currency = transaction.net?.currency ?? transaction.vat?.currency ?? null;
        const totalAmount = transaction.total?.signed_amount ?? null;

        return {
            id: transaction.id,
            type: DrillDownType.TRANSACTION,
            transactionId: transaction.id,
            description: transaction.description ?? null,
            relation_name: transaction.relation_name ?? null,
            date: transaction.booking_date ?? null,
            totalAmount,
            currency,
            netAmount,
            vatAmount,
        };
    });
}

export function mapVatUnusedItemsToDrillDownRows(items: VatDeclarationUnusedItem[]): BillDrillDownRow[] {
    return items.map((item) => {
        const money = item.total_amount_payable;
        const amountTotal = isMoney(money) ? money.signed_amount : null;
        const currency = isMoney(money) ? money.currency : null;
        const leftoverLineItemIds = (item.leftover_line_item_ids ?? []).filter((id) => id !== '');

        return {
            id: item.id,
            type: DrillDownType.BILL,
            documentId: item.document_id,
            file_name: item.file_name,
            relation_name: item.relation_name ?? null,
            date: item.normalized_date ?? null,
            totalAmount: amountTotal,
            currency,
            documentDrawerOptions: leftoverLineItemIds.length > 0
                ? {
                    lineItemsNeedingAttention: leftoverLineItemIds.map((lineItemId) => ({
                        lineItemId,
                        message: UNUSED_VAT_LINE_ITEM_MESSAGE,
                    })),
                }
                : {
                    allLineItemsMessage: UNUSED_VAT_LINE_ITEM_MESSAGE,
                },
        };
    });
}
